export { default as FlightDescription } from './FlightDescription.vue';
